import React, { Component } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { validateToken } from '../_actions';
import { hasRequiredRole } from '../_helpers/roles';

class PrivateRouteCMS extends Component {
  _isMounted = false;

  componentDidMount() {
    this._isMounted = true;
    this.checkAccess();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.checkAccess();
    }
  }

  checkAccess = () => {
    if (this.props.auth.user) {
      this.props.validateToken(this.props.auth.user.token);
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { component: Component, roles, ...rest } = this.props;
    const { user, validToken } = this.props.auth;

    return (
      <Route
        {...rest}
        render={props => {
          if (!user || !validToken) {
            return (
              <Redirect to={{ pathname: '/cms/login', state: { from: props.location } }} />
            );
          }

          if (roles && !hasRequiredRole(roles)) {
            return <Redirect to={{ pathname: '/cms/desktop', state: { from: props.location } }} />;
          }

          return <Component {...props} />;
        }}
      />
    );
  }
}

const mapStateToProps = state => ({ auth: state.authentication });
const mapDispatchToProps = dispatch => bindActionCreators({ validateToken }, dispatch);

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(PrivateRouteCMS);